import React from "react";
import CreatePasswordForm from "@components/Form/SetPasswordPostSignUpForm";
import FormWrapper from "@components/Wrappers/FormWrapper";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const CreatePasswordPage = () => {

    return (
        <VersionedLayout minimal>
            <FormWrapper pageTitle="Create Password">
                <CreatePasswordForm />
            </FormWrapper>
        </VersionedLayout>
    );
};

export default CreatePasswordPage;
